"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./display-logic-modal.less");
var context_meta_1 = require("@shared/types/context-meta");
var ranked_display_logic_1 = require("@shared/types/ranked-display-logic");
var lodash_1 = __importDefault(require("lodash"));
(function (module) {
    'use strict';
    var DisplayLogicModalController = function ($filter, $scope, displayLogicService, activeReport, sourceDataService, env) {
        var _a, _b;
        // The modal passes everything through the scope so we want to grab them and attach them
        // to the controller here
        lodash_1.default.merge(this, lodash_1.default.pick($scope, ['displayLogic', 'sourceId', 'setDisplayLogic']));
        this.$filter = $filter;
        this.$scope = $scope;
        this.displayLogicService = displayLogicService;
        this.$scope.$ctrl = this;
        this.translate = $filter('translate');
        this.sourceDataService = sourceDataService;
        this.env = env;
        this.sourceIds = activeReport.getMetadata(context_meta_1.CONTEXT_META_VARS.SURVEY_ID);
        this.sourceName = (_b = (_a = this.env.get('fieldsets')[this.sourceId]) === null || _a === void 0 ? void 0 : _a.definition) === null || _b === void 0 ? void 0 : _b.name;
    };
    DisplayLogicModalController.$inject = [
        '$filter',
        '$scope',
        'prDisplayLogicService',
        'prActiveReport',
        'prSourceDataService',
        'rsEnvironment',
    ];
    DisplayLogicModalController.prototype.$onInit = function () {
        this.allDisplayLogics = this.displayLogicService.getDisplayLogics();
        if (!this.allDisplayLogics.length) {
            // if there are no saved display logics, create a new one
            this.createNewDisplayLogic();
        }
        else {
            if (this.displayLogic && this.displayLogic.enabled) {
                // if switched from basic mode for the first time, preview the first display logic
                this.previewFirstDisplayLogic();
            }
            else {
                var self_1 = this;
                this.displayLogicToPreview = lodash_1.default.find(this.allDisplayLogics, function (d) {
                    return d._id === self_1.displayLogic;
                });
                if (!this.displayLogicToPreview) {
                    this.previewFirstDisplayLogic();
                }
            }
        }
        this.addSourceToDisplayLogics();
    };
    DisplayLogicModalController.prototype.addSourceToDisplayLogics = function () {
        var _this = this;
        lodash_1.default.forEach(this.allDisplayLogics, function (displayLogic) {
            _this.addSourceToDisplayLogic(displayLogic);
        });
    };
    /**
     * Modifies an existing display logic to be backwards compatible by assigning a source ID and name.
     * The display logic configs were updated with the ability to select field IDs,
     * so we need to lazily migrate old objects by adding a source to make them backwards compatible.
     */
    DisplayLogicModalController.prototype.addSourceToDisplayLogic = function (displayLogic) {
        if (!displayLogic.source) {
            displayLogic.source = {
                name: this.sourceName,
                sourceId: this.sourceId
            };
        }
    };
    DisplayLogicModalController.prototype.previewFirstDisplayLogic = function () {
        this.displayLogicToPreview = this.allDisplayLogics[0];
    };
    DisplayLogicModalController.prototype.previewDisplayLogic = function (displayLogic) {
        this.displayLogicToPreview = displayLogic;
    };
    /**
     * when a display logic is not selected and it's invalid,
     * decide if show error state (change the color to red and add caution icon)
     *
     * @param  {object} displayLogic
     * @return {boolean} if show error state or not
     */
    DisplayLogicModalController.prototype.showErrorState = function (displayLogic) {
        return !this.isSelected(displayLogic)
            && this.haveInvalidDisplayLogicsHelper(displayLogic);
    };
    DisplayLogicModalController.prototype.isSelected = function (displayLogic) {
        return displayLogic._id === this.displayLogicToPreview._id;
    };
    DisplayLogicModalController.prototype.createNewDisplayLogic = function () {
        var newDisplayLogic = this.displayLogicService.getNewDisplayLogic();
        // add new display logic to the beginning of allDisplayLogics array
        this.allDisplayLogics.unshift(newDisplayLogic);
        this.addSourceToDisplayLogic(newDisplayLogic);
        this.previewFirstDisplayLogic();
    };
    DisplayLogicModalController.prototype.copyDisplayLogic = function (displayLogic) {
        // use angular.copy instead of _.cloneDeep here to avoid $$hashkey being copied
        var displayLogicCopy = angular.copy(displayLogic);
        displayLogicCopy.name = displayLogicCopy.name + " " + this.translate('COPY');
        displayLogicCopy._id = this.displayLogicService.generateID();
        // add copy to the beginning of allDisplayLogics array 
        this.allDisplayLogics.unshift(displayLogicCopy);
        this.previewFirstDisplayLogic();
    };
    DisplayLogicModalController.prototype.deleteDisplayLogic = function (displayLogic) {
        // find the displayLogic by id and remove it from allDisplayLogics array
        this.allDisplayLogics = lodash_1.default.filter(this.allDisplayLogics, function (d) {
            return d._id !== displayLogic._id;
        });
        if (!this.allDisplayLogics.length) {
            // if there's no display logic after deleting, create a new (empty) one
            this.createNewDisplayLogic();
        }
        else if (this.displayLogicToPreview._id === displayLogic._id) {
            // if deleting the selected display logic, select the first one after deleting
            this.previewFirstDisplayLogic();
        }
    };
    /**
     * check if there's any invalid display logic in the allDisplayLogics array
     *
     * @return {boolean} if the allDisplayLogics array is invalid
     */
    DisplayLogicModalController.prototype.haveInvalidDisplayLogics = function () {
        var self = this;
        return lodash_1.default.some(this.allDisplayLogics, function (displayLogic) {
            return self.haveInvalidDisplayLogicsHelper(displayLogic);
        });
    };
    /**
     * the displayLogic is invalid if any property/element is empty
     *
     * @param  {object} displayLogic
     * @return {boolean} if the displayLogic is invalid
     */
    DisplayLogicModalController.prototype.haveInvalidDisplayLogicsHelper = function (displayLogic) {
        // if a single displayLogic object, check if every property is defined
        if (displayLogic.type === 'displayLogic') {
            var elements = this.displayLogicService.getElementsForValidation(displayLogic);
            return lodash_1.default.some(elements, function (el) {
                if (displayLogic.displayLogic.category === ranked_display_logic_1.RANKABLE_TIEMS) {
                    if (displayLogic.displayLogic.rankableValue === "Question" /* QUESTION */
                        && lodash_1.default.isUndefined(displayLogic.displayLogic.question)) {
                        return true;
                    }
                    else if (displayLogic.displayLogic.rankableValue === "Scoring Category" /* SCORING_CATEGORY */
                        && lodash_1.default.isUndefined(displayLogic.displayLogic.categories)) {
                        return true;
                    }
                }
                return lodash_1.default.isUndefined(displayLogic.displayLogic[el]);
            });
        }
        // if the displayLogic has children, check every child
        if (displayLogic.children && displayLogic.children.length) {
            var self_2 = this;
            return lodash_1.default.some(displayLogic.children, function (child) {
                return self_2.haveInvalidDisplayLogicsHelper(child);
            });
        }
        return false;
    };
    DisplayLogicModalController.prototype.saveDisplayLogicsAndClose = function () {
        // save displayLogic definition in report contextMeta
        this.displayLogicService.setDisplayLogics(this.allDisplayLogics);
        // save displayLogic id in widget dataConfig
        this.setDisplayLogic({
            displayLogic: this.displayLogicToPreview._id
        });
        this.close();
    };
    DisplayLogicModalController.prototype.close = function () {
        this.$scope.close();
        this.$scope.$destroy();
    };
    DisplayLogicModalController.prototype.getSourceIdOptions = function () {
        var _a, _b;
        var sourceId = (_b = (_a = this.displayLogicToPreview) === null || _a === void 0 ? void 0 : _a.source) === null || _b === void 0 ? void 0 : _b.sourceId;
        return this.sourceDataService.getUserSources(this.sourceIds)
            .then(function (sources) {
            return lodash_1.default.map(sources, function (source) {
                return {
                    label: source.name,
                    value: {
                        name: source.name,
                        sourceId: source.id
                    },
                    selected: sourceId === source.id
                };
            });
        });
    };
    DisplayLogicModalController.prototype.getSourceIdLabel = function () {
        var _a, _b;
        return ((_b = (_a = this.displayLogicToPreview) === null || _a === void 0 ? void 0 : _a.source) === null || _b === void 0 ? void 0 : _b.name) || this.translate('SELECT_SOURCE');
    };
    DisplayLogicModalController.prototype.setSource = function (value) {
        this.displayLogicToPreview.source = value;
    };
    module.controller('prDisplayLogicModalController', DisplayLogicModalController);
})(angular.module('qualtrics.pr'));
